import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import pictoCart from '~/assets/img/header/picto-cart@2x.png';
import CategoryStickyButtons from '~/components/organisms/Category/CategoryStickyButtons.vue';
import { extractSelectedFilters } from '~/helpers/extract-helper';

var SearchItem = function SearchItem() {
  return import(
  /* webpackChunkName: "search" */
  '~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
};

var LayerFullscreen = function LayerFullscreen() {
  return import(
  /* webpackChunkName: "layer" */
  '~/components/specific/MainHeader/LayerFullscreen.vue');
};

var AlgoliaSearch = function AlgoliaSearch() {
  return import('~/components/organisms/Category/AlgoliaSearch.vue');
};

export default {
  name: 'BannerMobile',
  components: {
    SearchItem: SearchItem,
    LayerFullscreen: LayerFullscreen,
    AlgoliaSearch: AlgoliaSearch,
    CategoryStickyButtons: CategoryStickyButtons
  },
  props: {
    cartUrl: {
      type: String,
      default: ''
    },
    homeUrl: {
      type: String,
      default: ''
    },
    accountUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      algoliaSearchComponent: null,
      algoliaSearch: null,
      isOpenMenu: false,
      mobile: true,
      pictoCart: pictoCart,
      search: '',
      isOpen: false,
      isSearchOpen: false,
      showFiltersButtons: false,
      selectedLayer: null,
      filters: null,
      showStickyFilters: null,
      scrollUp: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    total: 'cart/total',
    user: 'user/me',
    locale: 'i18n/locale',
    searchDescription: 'search/description',
    description: 'category/description',
    filterBy: 'pageActions/filterBy'
  })), {}, {
    htmlClasses: function htmlClasses() {
      var classes = ['global-wrapper'];

      if (this.isOpen) {
        classes.push('active-mobile');
      }

      return classes.join(' ');
    },
    activeStickyFilters: function activeStickyFilters() {
      return Boolean(this.$cookies.get('category-sticky-buttons'));
    }
  }),
  watch: {
    $route: function $route() {
      var isCategoryRoute = this.$route.path.indexOf('/c/') !== -1;
      var isKeywordRoute = this.$route.path.indexOf('/q/') !== -1;

      if (this.activeStickyFilters && (isCategoryRoute || isKeywordRoute)) {
        this.showFiltersButtons = true;
      } else if (this.activeStickyFilters && (!isCategoryRoute || !isKeywordRoute)) {
        this.showStickyFilters = false;
        this.scrollUp = false;
        this.showFiltersButtons = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.isCategoryTemplate() || this.isKeywordTemplate()) {
      this.$root.$on('sticky-filters-button', function (scrollReachedLimit, scrollUp) {
        _this.showFiltersButtons = scrollReachedLimit;
        _this.showStickyFilters = scrollReachedLimit;
        _this.scrollUp = scrollUp;
      });
    }

    this.$root.$on('open-search-mobile', function () {
      _this.isSearchOpen = true;
    });
    this.$root.$on('close-search-mobile', function () {
      _this.isSearchOpen = false;
    });
    this.$root.$on('close-algolia-search', function () {
      _this.closeSearch();
    });
    this.$root.$on('closeMenu', function (shouldChange) {
      if (shouldChange === false) return;

      _this.closeMenu();
    });
  },
  methods: {
    selectedFilters: function selectedFilters() {
      if (this.isCategoryTemplate() && this.filterBy && this.description) {
        return extractSelectedFilters(this.filterBy, this.description.filters);
      }

      if (this.isKeywordTemplate() && this.filterBy && this.searchDescription) {
        return extractSelectedFilters(this.filterBy, this.searchDescription.filters);
      }

      return [];
    },
    isCategoryTemplate: function isCategoryTemplate() {
      return this.$route.path.indexOf('/c/') !== -1;
    },
    isKeywordTemplate: function isKeywordTemplate() {
      return this.$route.path.indexOf('/q/') !== -1;
    },
    closeSearch: function closeSearch() {
      this.isOpenMenu = false;
      this.algoliaSearchComponent = null;

      if (this.algoliaSearch) {
        this.$root.$emit('generic-tracking', null, {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Fermer'
          }
        });
        this.$root.$emit('reset-tcvars');
      }
    },
    toggleSearch: function toggleSearch() {
      this.algoliaSearch = this.$cookies.get('algolia') && this.locale.iso === 'fr-FR';
      var tracking = {
        data: {
          event_category: 'Header',
          event_action: 'Search',
          event_label: 'ES_Clic'
        }
      };

      if (this.algoliaSearch) {
        this.isOpenMenu = true;
        this.algoliaSearchComponent = AlgoliaSearch;
        tracking = {
          data: {
            event_category: 'Header',
            event_action: 'Search',
            event_label: 'Algolia_Clic'
          }
        };
      } else {
        this.isSearchOpen = !this.isSearchOpen;

        if (this.isSearchOpen) {
          this.$refs.search.$refs.search.focus();
        } else {
          this.$refs.search.resetForm();
        }
      }

      this.$root.$emit('generic-tracking', null, tracking);
    },
    tracking: function tracking(evt, data) {
      this.$root.$emit('generic-tracking', evt, {
        data: _objectSpread({
          event_category: 'Header',
          event_action: '',
          event_label: ''
        }, data)
      });
    }
  },
  head: function head() {
    return {
      htmlAttrs: {
        class: this.htmlClasses
      }
    };
  }
};